import AuthMethod from './auth_method.model';

/**
 * Read minimal data of an auth method retrieved from the backend.
 * @param {Object} o
 * @return {AuthMethod}
 */
function readAuthMethod(o) {
  return new AuthMethod(
    o.name,
    o.logo_url,
    o.auth_id
  );
}

export {
  readAuthMethod
};



// WEBPACK FOOTER //
// ./src/app/auth_method/auth_method.serializer.js